import { Action, Dispatch } from 'redux'
import { initStoreDeliveryFeesAction } from 'reducks/storeDeliveryFee/actions'

const initStoreDeliveryFees = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(initStoreDeliveryFeesAction())
  }
}

export default initStoreDeliveryFees
